import {
  Input, SimpleChanges, OnChanges,
  ViewChild,
  Component,
  OnInit
} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {SessionDateVM} from "../../models/SessionDateVM.model";
import {SessionTimeVM} from "../../models/SessionTimeVM.model";
import {CategoryService} from "../../services/category/category.service";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from "../../services/auth/AuthService";
import {AuthGuard} from "../../services/auth/AuthGuard";
import {TranslateService} from "ng2-translate";
import {PaymentResultVM, STATUS_CREATED, STATUS_OK} from "../../models/PaymentResultVM.model";
import {OrderBagService} from "../../services/orderbag/orderbag.service";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {PriceInfoDetailVM} from "../../models/PriceInfoDetailVM.model";
import {AlertService} from "../../services/alert/alert.service";
import {ParticipantVM} from "../../models/ParticipantVM.model";
import {TotalPriceVM} from "../../models/TotalPriceVM.model";
import {OrderBagItemVM} from "../../models/OrderBagItemVM.model";
import {OrderBagItemDetailVM} from "../../models/OrderBagItemVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {PAYMENT_WEB_URL} from '../../services/constants';
import {Router} from '@angular/router';
import {LoginComponent} from "../../login/login.component";
import * as moment from 'jalali-moment';
import {SelectDateDialog} from "../shared/select-date-dialog/select-date-dialog.component";
import {SelectDateDialogV2} from "../shared/select-date-dialog/select-date-dialog-v2.component";
import {Data} from "../../../../node_modules/@agm/core/services/google-maps-types";
import {Location} from "@angular/common";
import {PlatformLocation} from '@angular/common'
import * as Moment from 'moment';
import {IntakeFormComponent} from "../intake-form/intake-form.component";
import {IntakeFormVM} from "../../models/IntakeForm.model";
import {ServantVM} from "../../models/ServiceItemDetailVM";
import {SupportedCompanyInformationDialogComponent} from "../supported-company-information-dialog/supported-company-information-dialog.component";
import {IAppConfig} from "../../models/app-config.model";
import {AppConfig} from "../../services/app.config";
import {DialogTermsAndConditionsComponent} from "../shared/dialog-termsAndConditions/dialog-termsAndConditions.component";
import {CouponResultVM} from "../../models/CouponResultVM.model";
import {Observable} from 'rxjs/Rx';
import {PersianDatePickerV2Component} from "../shared/date-picker-v2/date-picker-v2.component";
import {DateUtilService} from "../../services/date-service/DateUtilService";
import {PermissionService} from "../../services/permission/permission.service";
import {RWDatePickerComponent} from "../shared/rw-date-picker/rw-date-picker.component";
import {PersonService} from "../../services/person/person-service";
import {CompanyCustomerVM} from "../../models/CompanyCustomerVM.model";
import {CustomerIntakeDataComponent} from "../customer-intake-data/customer-intake-data.component";
import {CustomerVM} from "../../models/CustomerVM.model";
import {PersonInfoVM} from "../../models/PersonInfoVM.model";
import {DialogServantProfileComponent} from "../servant-profile/dialog-servant-profile.component";
import {ServiceOptionVM} from "../../models/ServiceOptionVM.model";

//import {OrderBagItemVM} from "../../models/OrderBagItemVM.model";
export interface DialogData {
  user: string;
  password: string;
}

@Component({

  selector: 'rw-book-toolbar-v2',  // <home></home>

  providers: [
    DateUtilService,PersonService
  ],

  styles: [require('./book-toolbar-v2.component.scss')],

  template: require('./book-toolbar-v2.component.html')
})
export class BookToolbarV2Component implements OnInit, OnChanges {
  public Steps: any[] =
    [
      {stepNumber: 0, title: 'SELECT_SERVANT', included: false, disabled: true, expanded: false},
      {stepNumber: 1, title: 'SELECT_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 1.1, title: 'SELECT_DATE_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2, title: 'SELECT_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2.1, title: 'SELECT_FROM_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2.2, title: 'SELECT_TO_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 3, title: 'SELECT_EVENT_TIMES', included: false, disabled: true, expanded: false},
      {stepNumber: 4, title: 'SELECT_QTY', included: false, disabled: true, expanded: false},
      {stepNumber: 5, title: 'GET_PARTICIPANTS', included: false, disabled: true, expanded: false},
      {stepNumber: 6, title: 'SELECT_OPTIONS', included: false, disabled: true, expanded: false},
      {stepNumber: 6.1, title: 'SELECT_MULTIPLE_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 6.2, title: 'AUTO_MULTIPLE_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 6.3, title: 'INTAKE_FORM', included: false, disabled: true, expanded: false},
      {stepNumber: 6.4, title: 'LOGIN_FORM', included: true, disabled: true, expanded: false},
      {stepNumber: 6.5, title: 'CUSTOMER_INTAKE_DATA', included: false, disabled: true, expanded: false},
      {stepNumber: 6.6, title: 'CONFIRM_AGREEMENT', included: false, disabled: true, expanded: false},
      {stepNumber: 7, title: 'CONFIRM', included: true, disabled: true, expanded: false}

    ];
  public currentStep: any;
  private NOT_ALLOWED_MULTIPLE_TIME_TYPE = 'DAILY';

  @Input() public serviceItemDetail: ServiceItemDetailVM;
  @Input() public activePrice: any;
  @Input() public servantId;
  public setting: IAppConfig = AppConfig.settings;
  public noPasswordLoginEnabled=false;
  public sessionDates: SessionDateVM[] = [];
  public activeDays: Array<SessionDateVM>;
  public busy;
  public busy_to_compute_priceInfo_list;
  public busy_to_compute_price;
  public busy_to_fill_times;
  public orderBagComment: string = '';
  public sessionTimes: SessionTimeVM[] = [];
  public sessionTimesAM: SessionTimeVM[] = [];
  public sessionTimesPM: SessionTimeVM[] = [];
  public endSessionTimesAM: SessionTimeVM[] = [];
  public endSessionTimesPM: SessionTimeVM[] = [];
  public toSessionTimes: SessionTimeVM[] = [];
  public qtyOptions: number[] = [];
  public priceInfos: PriceInfoDetailVM[] = [];
  public selectedDate: Date;
  public selectedTime: SessionTimeVM = new SessionTimeVM();
  public toSelectedTime: SessionTimeVM = new SessionTimeVM();
  public selectedServant: ServantVM;
  public showCalendar: boolean = false;
  public baseurl;
  public canAddToCard: boolean = false;
  public loading: boolean;
  public fromDateMessage: String;
  public fromTimeMessage: String;
  public toTimeMessage: String;
  public orderBag: OrderBagVM;
  public totalPrice: OrderBagVM ;
  public bookWasSuccessful: boolean = false;
  public userCanHaveInplacePayment = false;
  public userShouldPay = false;
  public bookComment: string = '';
  public orderBagItem: OrderBagItemVM;
  public isInstantBooking = true;
  public isFloatSchedule = true;
  public isMultipleTime = false;
  public isMultipleDate = false;
  public availableCapacity: number = 0;
  public qty_unit: string = 'نفر';
  public servant_label = 'پرسنل';
  public canSelectMultipleDates: boolean = false;
  public isAutoSelectMultipleDates: boolean = false;
  public canSelectServant: boolean = false;
  public isAllAutoDatesAreFilled: boolean = false;
  public newMultipleDate: Date;
  public hasIntakeForm: boolean = false;
  public showPrePayment: boolean = false;
  public notTimeAvailable: boolean = false;
  public maxQty: number;
  public priceInfoComputed = false;
  public needToBookTheReserveAfterLogin: boolean = false;
  public confirmOrderFromSupport: boolean = false;
  public showCapacity: boolean = false;
  public loggedInUser:any=null;
  public hasTheMustConfirmAgreement: boolean = false;
  public acceptsTermsAndConditions: boolean = false;
  public showTermsAndConditionsAlert: boolean = false;
  user: string;
  password: string;
  public couponResult: CouponResultVM;
  public showCouponResult: boolean = false;
  public showFindFirstAvailableDate:boolean=false;
  public showCouponSection: boolean = false;
  public isAnyServantHasCustomPrice : boolean = false;
  public showPrice : boolean = true;
  public showCustomerIntakeData : boolean = false;
  public companyCustomer : CompanyCustomerVM = new CompanyCustomerVM();
  public isSaving : boolean = false;
  public isEventMode : boolean = false;
  public justShowSlotStartTime : boolean = false;
  optionsWithQty = [];
  optionsWithNoQty = [];
  public consecutiveLimitMsg :string ="";
  public userCanHaveOnlinePayment:boolean = true;



  @ViewChild(IntakeFormComponent) intakeFormComponent: IntakeFormComponent;
  @ViewChild(PersianDatePickerV2Component) datePickerComponent: PersianDatePickerV2Component;
  @ViewChild(RWDatePickerComponent) rwDatePicker:RWDatePickerComponent;
  @ViewChild(CustomerIntakeDataComponent) customerIntakeDataComponent: CustomerIntakeDataComponent;


  constructor(private location: PlatformLocation, private authService: AuthService,private personService: PersonService,
              public dialog: MatDialog,
              private router: Router, private companyService: CompanyService, private categoryService: CategoryService, private orderBagService: OrderBagService, private authGuard: AuthGuard,
              private translate: TranslateService, private _formBuilder: FormBuilder, private alertService: AlertService) {

  }

  public ngOnInit() {

    this.initSteps();
    this.checkIfUserCanPayInPlace();

    let parent = this;

    //init customer
    parent.companyCustomer.customer = new CustomerVM();
    parent.companyCustomer.customer.personalInfo = new PersonInfoVM();
    //.........................

  }

  initSteps() {
    this.Steps.forEach((s) => {
      s.ptitle = this.getStepTitle(s.stepNumber);
    })
  }

  refreshSteps() {
    let parent = this;
    parent.Steps.forEach((s) => {
      s.disabled = this.isStepDisabled(s.stepNumber);
      s.expanded = this.isStepExpanded(s.stepNumber);
    })
  }

  ngOnChanges(changes: SimpleChanges): void {

    let parent = this;

    if (this.servantId) {

      //let servantIdTemp:number = +this.servantId;
      this.serviceItemDetail.servants.forEach(element => {
        if (parent.servantId == element.id) {
          parent.selectedServant = element;
          parent.selectServant(parent.selectedServant);
        }
      })

    }

    this.initOrderBagItem();
    if (this.serviceItemDetail) {

      if (this.serviceItemDetail.servants && this.serviceItemDetail.servants.length > 0 && (!this.serviceItemDetail.servantSelectMode || this.serviceItemDetail.servantSelectMode == 'SELECT_BY_CUSTOMER')) {
        this.canSelectServant = true;
      }
      if (this.serviceItemDetail.multiReserveMode === "MANUAL")
        this.canSelectMultipleDates = true;
      if (this.serviceItemDetail.multiReserveMode === "AUTO") {
        this.isAutoSelectMultipleDates = true;

      }
      if (this.serviceItemDetail.agreement && this.serviceItemDetail.agreement.mustConfirmAgreement == true)
        this.hasTheMustConfirmAgreement = true;
      if (this.serviceItemDetail.confirmationType == 'TWO_STEP')
        this.isInstantBooking = false;

      if (this.serviceItemDetail.serviceMode === "EVENT")
        this.isEventMode = true;

      //if (this.serviceItemDetail.scheduleInfo && this.serviceItemDetail.scheduleInfo.scheduleType == 'FLOAT_TIME_SESSIONS') {
      //
      //
      //  parent.isFloatSchedule = true;
      //
      //
      //}
      parent.isMultipleTime = true;
      if (this.serviceItemDetail.consecutiveReserveMode == 'DISABLE') {
        parent.isMultipleTime = false;
      }


      //old
      // let qu = this.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'qty_unit');

      let qu = null;
      if(this.serviceItemDetail.capacityInfo.qtyUnit)
        qu = this.serviceItemDetail.capacityInfo.qtyUnit;


      parent.companyService.getCompanyInfo().subscribe((company) => {
        let mode = parent.companyService.getCompanyCustomSetting(company, 'capacityViewMode');

        let noPasswordEnabled=parent.companyService.getCompanyCustomSetting(company, 'noPassLoginEnabled');
        if(noPasswordEnabled)
          parent.noPasswordLoginEnabled=true;
        if (mode == 'SHOW') {
          parent.showCapacity = true;
        }
        let serLabel = this.companyService.getCompanyCustomSetting(company, 'servant_label');
        if (!serLabel)
          serLabel = parent.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'servant_label');
        if (serLabel) {
          parent.servant_label = serLabel;
        }

        let priceViewMode = parent.companyService.getCompanyCustomSetting(company, 'priceViewMode');
        if (priceViewMode && priceViewMode.toLowerCase() == 'hide')
          parent.showPrice = false;


        let justShowStartTime = parent.companyService.getCompanyCustomSetting(company, 'justShowStartTime');
        if (justShowStartTime)
            parent.justShowSlotStartTime = justShowStartTime;


      });


      //old version
      // parent.maxQty = this.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'max_qty');

      //new version
      parent.maxQty = null;
      if(this.serviceItemDetail.capacityInfo.maxQty)
        parent.maxQty = this.serviceItemDetail.capacityInfo.maxQty;


      if (qu) {
        this.qty_unit = qu;

      }
      if (this.serviceItemDetail.intakeForm && this.serviceItemDetail.intakeForm.fields && this.serviceItemDetail.intakeForm.fields.length > 0)
        this.hasIntakeForm = true;
      this.fillOptions();
      this.includeSteps();
      this.refreshSteps();
      if (!this.serviceItemDetail.servants || this.serviceItemDetail.servants.length == 0) {
        this.fillDates(this.optionMethod);
      } else if (!this.canSelectServant && this.serviceItemDetail.servants.length > 1) {
        this.autoSelectServant(function (selectedServant) {
          parent.selectServant(selectedServant);
        })
      }
      else if (this.serviceItemDetail.servants && this.serviceItemDetail.servants.length == 1 && !this.selectedServant) {
        this.selectServant(this.serviceItemDetail.servants[0]);

      }

    }


    this.sortServants();

  }

  optionMethod() {

  }

  setStep(index: number) {

    if (!this.Steps[index].disabled) {
      this.currentStep = this.Steps[index];
      this.refreshSteps();
    }


  }

  isStepDisabled(index: number) {
    return (this.getStepByStepNumber(index).stepNumber > this.currentStep.stepNumber);
  }

  isStepExpanded(index: number) {
    return (this.getStepByStepNumber(index).stepNumber == this.currentStep.stepNumber);
  }

  getStepTitle(index: number) {
    let key = 'book.steps.' + this.getStepByStepNumber(index).title;
    return key;
  }

  getStepByStepNumber(index: number) {
    let steps = this.Steps.filter((s) => {
      return s.stepNumber == index
    });
    if (steps && steps.length > 0)
      return steps[0];
  }

  setFirstStep() {
    let parent = this;
    let found = false;
    this.Steps.forEach((s) => {
      if (!found && (-1 < s.stepNumber && s.included)) {
        parent.currentStep = s;
        found = true;
      }
    });
    parent.currentStep.disabled = false;
    parent.currentStep.expanded = true;

  }

  nextStep() {

    let parent = this;
    let found = false;
    let nextStep: any = parent.currentStep;
    parent.Steps.forEach((s) => {

      // if (this.serviceItemDetail.servants.length === 1 && parent.Steps[1].expanded === false){
      //   parent.Steps[1].expanded = true;
      //   parent.Steps[s].expanded = false;
      // } else {
      //
      // }
      if (!found && (nextStep.stepNumber < s.stepNumber && s.included)) {
        nextStep = s;
        found = true;
      }

    });


    if (nextStep.title == 'CONFIRM') {
      parent.onFinalStep(function () {
        parent.currentStep = nextStep;
        parent.refreshSteps();
      });
    }
    else if (nextStep.title == 'SELECT_MULTIPLE_DATE') {
      parent.doBeforeMultipleDateStep();
      parent.currentStep = nextStep;
      parent.refreshSteps();
    }
    else if (nextStep.title == 'AUTO_MULTIPLE_DATE') {
      parent.doBeforeMultipleDateStep();
      parent.currentStep = nextStep;
      parent.refreshSteps();
    } else {
      parent.currentStep = nextStep;
      ;
      parent.refreshSteps();
    }

  }

  gotoPrevStep() {

    //   if(this.currentStep.stepNumber==1)return true;

    //  if(this.currentStep.stepNumber==2)
    this.setStep(0);
    return false;
  }

  doBeforeMultipleDateStep() {

    this.clearExtraOrderBagItems();
    this.fillOrderBagObject();
    if (this.isAutoSelectMultipleDates) {
      this.AddDaysAutomatic();
    }

  }

  confirmMultiDateSelect() {
    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1)
  }


  confirmQty() {
    let parent = this;
    let totalQty = this.getTotalQty();
    if (totalQty > 0) {
      if (totalQty <= this.availableCapacity) {
        parent.makeParticipantList();
        setTimeout(function () {
          parent.nextStep();
        }, 1);
      }
      else {

        parent.alertService.showErrorMessage("برای هر نوبت حداکثر" + this.availableCapacity + " نفر قابل رزرو است");
      }
    }
    else {
      parent.alertService.showErrorMessage("تعداد رزرو را انتخاب کنید");
    }

  }

  confirmParticipant() {
    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1)

  }
  confirmUserInfo() {
    let parent = this;

    if(this.showCustomerIntakeData)
    {
      this.companyService.getCompanyInfo().subscribe((company) => {
        this.setCompanyCustomerData(company);
      });
    }

    setTimeout(function () {
      parent.nextStep();
    }, 1)

  }

  setCompanyCustomerData(company)
  {
    this.companyService.getCompanyCustomerForDataEntry(company.id).subscribe(cc => {
      this.companyCustomer = cc;
      // this.companyService.getCompanyCustomerIntakeData(company.id).subscribe(res => {
      //   if(res)
      //     this.companyCustomer.customerIntakeData = res;
      // });
    });
  }


  onUserChanged(user)
  {
    this.loggedInUser=user;
    //alert('user changed');
  }

  confirmOptions() {


    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1);

  }

  includeSteps() {

    this.Steps.forEach((step) => {
      switch (step.title) {
        case 'SELECT_SERVANT':
          if (this.canSelectServant)
            step.included = true;
          break;
        case 'SELECT_DATE':
          if (!this.isMultipleDate && !this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_FROM_TIME':
          if (this.isFloatSchedule && !this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_TO_TIME':
          if (this.isFloatSchedule && this.isMultipleTime && !this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_TIME':
          if (!this.isMultipleDate && !this.isFloatSchedule && !this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_DATE_TIME':
          if (this.isMultipleDate && !this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_EVENT_TIMES':
          if (this.isEventMode)
            step.included = true;
          break;
        case 'SELECT_QTY':
          if (this.serviceItemDetail.capacityInfo && this.serviceItemDetail.capacityInfo.qty > 1) {
            step.included = true;

          }
          if (this.maxQty) {
            this.serviceItemDetail.capacityInfo.qty = this.maxQty;
            if (this.maxQty == 1) {
              step.included = false;
            }
          }
          if (this.serviceItemDetail.priceInfoDtails && this.serviceItemDetail.priceInfoDtails.length > 1) {
            step.included = true;
          }
          break;
        case 'GET_PARTICIPANTS':
          if (this.serviceItemDetail.mustGetParticipantInfo)
            step.included = true;


          break;

        case 'SELECT_OPTIONS':

          if (this.orderBagItem.options && this.orderBagItem.options.length > 0)
            step.included = true;
          break;
        case 'SELECT_MULTIPLE_DATE':


          if (this.canSelectMultipleDates)
            step.included = true;

          break;

        case 'AUTO_MULTIPLE_DATE':
          if (this.isAutoSelectMultipleDates)
            step.included = true;

          break;
        case 'INTAKE_FORM':
          if (this.hasIntakeForm)
            step.included = true;

          break;

        case 'CUSTOMER_INTAKE_DATA':
          if (this.showCustomerIntakeData)
            step.included = true;

          break;

        case 'CONFIRM_AGREEMENT':
          if (this.hasTheMustConfirmAgreement)
            step.included = true;

          break;

      }


    })
    this.setFirstStep();
  }

  makeParticipantList() {
    let parent = this;
    parent.orderBagItem.participantPersons = [];
    for (let i = 0; i < this.getTotalQty(); i++) {
      parent.orderBagItem.participantPersons.push(new ParticipantVM());
    }
  }

  fillPriceInfos() {
    let parent = this;
    parent.loading = true;
    if (this.isFloatSchedule) {
      let servantId = null;
      if (this.selectedServant && this.selectedServant.id)
        servantId = this.selectedServant.id;
      this.busy_to_compute_priceInfo_list = this.orderBagService.getPriceInfoDetailByServiceIdAndServantIdAndStartDate(this.serviceItemDetail.id, servantId, this.selectedTime.startTime).subscribe(
        {
          next(prices) {
            // Sort
            prices.sort((a,b) => a.title.localeCompare(b.title));
            parent.orderBagItem.orderBagServiceItemDtail = [];
            if (prices) {
              prices.forEach((priceInfo) => {
                let orderBagServiceItemDtail = new OrderBagItemDetailVM();
                orderBagServiceItemDtail.priceInfoDtail = priceInfo;
                parent.orderBagItem.orderBagServiceItemDtail.push(orderBagServiceItemDtail)
              })
            }
            if (parent.orderBagItem.orderBagServiceItemDtail.length == 1)
              parent.orderBagItem.orderBagServiceItemDtail[0].gty = 1;

            parent.calculateMaxAvailableCapacity();
            parent.nextStep();
            parent.loading = false;
          },
          error(err) {
            parent.busy_to_compute_priceInfo_list = false;
            parent.loading = false;
          }
          ,
          complete() {

          }
        }
      );
    } else {
      this.busy_to_compute_priceInfo_list = this.orderBagService.getPriceInfoDetailByServiceIdAndTimeSession(this.serviceItemDetail.id, this.selectedTime.id).subscribe(
        {
          next(prices) {

            parent.loading = false;
            parent.orderBagItem.orderBagServiceItemDtail = [];
            if (prices) {
              prices.forEach((priceInfo) => {
                let orderBagServiceItemDtail = new OrderBagItemDetailVM();
                orderBagServiceItemDtail.priceInfoDtail = priceInfo;
                parent.orderBagItem.orderBagServiceItemDtail.push(orderBagServiceItemDtail)
              })
            }
            if (parent.orderBagItem.orderBagServiceItemDtail.length == 1)
              parent.orderBagItem.orderBagServiceItemDtail[0].gty = 1;
            parent.calculateMaxAvailableCapacity();

            parent.nextStep();
          }
          ,
          error(err) {
            parent.busy_to_compute_priceInfo_list = false;
            parent.loading = false;
          },
          complete() {

          }
        }
      );
    }
  }

  fillQtyOptions(maxCapacity) {
    this.qtyOptions = [];
    for (let i = 1; i <= maxCapacity; i++)
      this.qtyOptions.push(i);
  }

  fillOptions() {
    let parent = this;
    parent.optionsWithQty = [];
    parent.optionsWithNoQty = [];
    parent.orderBagService.getServiceItemOptionsByServiceItemid(parent.serviceItemDetail.id).subscribe(function (options) {
      options.forEach((option)=> {
        if(option.qtyType && option.qtyType == 'HAS_QTY')
        {
          option.selected = true;
          option.qty = option.minQty;

          parent.optionsWithQty.push(option);
        }
        else{
          parent.optionsWithNoQty.push(option);
        }
      })
      parent.orderBagItem.options = parent.getOptions();
      parent.includeSteps();
    });
  }

  getOptions(){
    let parent = this;
    let options = [];
    // options.push(parent.optionsWithQty);
    // options.push(parent.optionsWithNoQty);

    options = [ ...parent.optionsWithQty, ...parent.optionsWithNoQty];

    return options;
  }

  getQtyOptions(priceInfo) {
    let selectableList: number[] = [];
    for (let i = 1; i <= this.availableCapacity; i++) {
      selectableList.push(i);
    }


    return selectableList;
  }

  calculateMaxAvailableCapacity() {
    let parent = this;
    let selectableList: number[] = [];
    if (!this.isMultipleTime) {
      if (this.selectedTime && this.selectedTime.capacity) {
        this.availableCapacity = this.selectedTime.capacity;
        if (parent.maxQty && parent.maxQty < this.availableCapacity)
          this.availableCapacity = parent.maxQty;
      }
    } else {
      let timeSpan: SessionTimeVM = new SessionTimeVM();
      timeSpan.startTime = this.selectedTime.startTime;
      timeSpan.endTime = this.toSelectedTime.endTime;
      timeSpan.serviceItemId = this.serviceItemDetail.id;

      this.orderBagService.getAvailableCapacity(timeSpan).subscribe((ts) => {
        parent.availableCapacity = ts.capacity;
        if (parent.maxQty && parent.maxQty < ts.capacity)
          ts.capacity = parent.maxQty;

      })
    }
    return selectableList;
  }

  getTotalQty() {

    let totalqty: number = 0;
    if (this.orderBagItem && this.orderBagItem.orderBagServiceItemDtail) {
      this.orderBagItem.orderBagServiceItemDtail.forEach((pi) => {
        if (pi.priceInfoDtail) {
          pi.priceInfoDtailId = pi.priceInfoDtail.id;
        }
        if (pi.gty && pi.gty > 0)
          totalqty += pi.gty;
        else
          totalqty += 0;
      })
    }
    return totalqty;
  }

  addDays(date, days: number) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  fillDates(then) {
    let parent = this;
    this.sessionDates = [];
    parent.showCalendar = false;
    if (!this.canSelectServant || (this.selectedServant && this.selectedServant.id)) {
      let from = new Date();
      let to = new Date();
      to = this.addDays(to, 90);


      let servantId = null;
      if (this.selectedServant && this.selectedServant.id)
        servantId = this.selectedServant.id;
      this.categoryService.getServiceSessionDatesByServiceidAndServant(this.serviceItemDetail.id, servantId, from, to).subscribe(sd => {
        parent.sessionDates = sd;
        parent.activeDays = [];

        parent.activeDays = sd;
        //parent.sessionDates.forEach((sd) => {
        //  parent.activeDays.push(new Date(sd.startDate.toString()));
        //});
        if (parent.activeDays.length > 0) {
          parent.showCalendar = true;
          parent.showFindFirstAvailableDate = true;
          // this.selectedDate = this.sessionDates[0].startDate;
          parent.fillTimes();
        }
        if (then)
          then();
      }, error => {
      });
    }
  }

  selectedDateChanged(event) {
    if (event) {
      this.selectedDate = event;
      this.fillTimes();

    }
  }

  selectedMultipleDate(event) {

  }

  onFinalStep(then) {
    this.computeOrderbagPrice(then);
  }

  onFromTimeChanged(e) {

    let parent = this;
    this.selectedTime = e;
    this.toSelectedTime = null;
    if (e) {
      this.toSessionTimes = this.sessionTimes.filter((st) => {
        return st.startTime >= e.startTime;
      });

    }
  }

  onToTimeChanged(e) {
    this.toSelectedTime = e;
    //   this.computeOrderbagPrice();
  }

  confirmDateAndTime() {
    let isValid = this.validateBookingTimeStep();
    if (isValid) {
      if (this.authService.isAuthenticated) {

        this.changeStep(1);
      } else {
        this.authGuard.openLoginDialog();
      }
    }
  }

  fillTimes() {
    let parent = this;
    if (this.serviceItemDetail && this.selectedDate) {

      this.selectedDate = new Date(this.selectedDate.toString());
      parent.loading = true;
      let servantid = null;
      if (this.selectedServant && this.selectedServant.id)
        servantid = this.selectedServant.id;

      parent.busy_to_fill_times = this.categoryService.getServiceSessionTimesByServiceidAndServant(this.serviceItemDetail.id, servantid, this.selectedDate).subscribe(
        {
          next(sd) {

            parent.sessionTimes = sd;
            parent.splitSessionTimes(parent.sessionTimes);
            parent.notTimeAvailable = true;
            parent.sessionTimes.forEach(function (t) {
              // if (t.capacity > 0 && !parent.isExpired(t.startTime))
              if (t.capacity > 0)
                parent.notTimeAvailable = false;
            })
            parent.loading = false;
            parent.nextStep();
            parent.toSessionTimes = [];
            parent.loading = false;
            parent.busy_to_fill_times = false;
          },
          error(err) {
            parent.loading = false;
            parent.busy_to_fill_times = false;
          },
          complete() {
          }
        }
      );
    }
    else {
      this.sessionTimes = [];
      this.toSessionTimes = [];
    }
  }

  isExpired(date) {
    try {
      let mTime = moment(new Date(date));
      let newDate = new Date() ;


      //F... REGIME!!
      if(this.isDateInFirstHalf(newDate))
        newDate.setHours(newDate.getHours()-1);
      //.....................................

      let now = moment(newDate);
      return (mTime.isBefore(now))
    } catch (ex) {
      return false;
    }

  }

  fillEndTimes() {
    let parent = this;
    let filteredEndTimes = [];
    let maxEvailableTime = parent.selectedTime;
    let nextNotAvailableTimeFound = false;
    let mselectedTime = moment(new Date(parent.selectedTime.startTime));


    //consecutive limit check
    let minPeriod = new Date(this.selectedTime.endTime).getTime() -  new Date(this.selectedTime.startTime).getTime();
    let minPeriodInMinutes = Math.round(minPeriod / 60000);
    let mselectedTimeWithMinPeriod = moment(new Date(parent.selectedTime.startTime)); ;
     mselectedTimeWithMinPeriod = mselectedTimeWithMinPeriod.add(this.serviceItemDetail.minConsecutivePeriod * minPeriodInMinutes , 'minutes');

    let mselectedTimeWithMaxPeriod = moment(new Date(parent.selectedTime.startTime)); ;
    mselectedTimeWithMaxPeriod = mselectedTimeWithMaxPeriod.add(this.serviceItemDetail.maxConsecutivePeriod * minPeriodInMinutes , 'minutes');



    this.sessionTimes.forEach(t => {
      let mTime = moment(new Date(t.endTime));

      if (!nextNotAvailableTimeFound && mTime.isAfter(mselectedTime)) {
        if (t.capacity > 0) {
          let nextTimeRange = moment(new Date(maxEvailableTime.endTime)).add(5, 'minutes');
          let currentStartTime = moment(new Date(t.startTime));

          //checcking if next time is just after last maxTime
          if (currentStartTime.isBefore(nextTimeRange)) {
            maxEvailableTime = t;
          } else {
            nextNotAvailableTimeFound = true;
          }
        } else {

          nextNotAvailableTimeFound = true;
        }
      }
    });

    this.sessionTimes.forEach(t => {
      let tcopy = JSON.parse(JSON.stringify(t))
      let mTime = moment(new Date(t.endTime));
      let mselectedTime = moment(new Date(parent.selectedTime.startTime));
      tcopy.disabled = !(t.capacity > 0);
      if (mTime.isSameOrBefore(mselectedTime) || mTime.isAfter(maxEvailableTime.endTime))
        tcopy.disabled = true;

      // consecutive limit check
      if(mTime.isBefore(mselectedTimeWithMinPeriod))
        tcopy.disabled = true;

      if(mTime.isAfter(mselectedTimeWithMaxPeriod))
        tcopy.disabled = true;


      filteredEndTimes.push(tcopy);
    })

    this.splitEndSessionTimes(filteredEndTimes);
  }

  initOrderBagItem() {
    this.orderBag = new OrderBagVM();

    this.orderBagItem = new OrderBagItemVM();
    this.orderBagItem.serviceItem = new ServiceItemVM();
    this.orderBagItem.orderBagServiceItemDtail = [];
    this.orderBagItem.options = [];
    this.orderBagItem.totalPrice = new TotalPriceVM();
    this.orderBagItem.participantPersons = [];
    this.orderBagItem.timeSession = new SessionTimeVM();
    this.orderBag.orderBagServiceItems.push(this.orderBagItem);
  }

  splitSessionTimes(times) {
    let parent = this;
    if (times) {
      times = parent.sortSessionTimes(times);
      parent.sessionTimesAM = []
      parent.sessionTimesPM = []
      times.forEach((t) => {

        if (t.capacity <= 0)
          t.disabled = true;

        //check time is expired
        if(!t.disabled && this.isExpired(t.startTime))
          t.disabled = true;

        let st = new Date(t.startTime);
        if (st.getHours() < 12)
          parent.sessionTimesAM.push(t);
        else
          parent.sessionTimesPM.push(t);

      })
    }
  }

  sortSessionTimes(times){
    return times.sort((a, b) => {
        return (a.startTime < b.startTime ? -1 : 1);
    })
  }

  splitEndSessionTimes(times) {
    let parent = this;
    if (times) {
      parent.endSessionTimesAM = [];
      parent.endSessionTimesPM = [];
      times.forEach((t) => {

        if (t.capacity > 0) {
          let st = new Date(t.endTime);
          if (st.getHours() < 12)
            parent.endSessionTimesAM.push(t);
          else
            parent.endSessionTimesPM.push(t);
        }
      })
    }
  }

  changeStep(index: number) {
    // this.bookingStepper.next();

  }

  resetMessage() {
    this.fromDateMessage = '';
    this.fromTimeMessage = '';
    this.toTimeMessage = '';
  }

  selectTime(select) {

    this.selectedTime = select;
    this.fillPriceInfos();


  }

  selectStartTime(select) {
    let parent = this;
    parent.selectedTime = select;
    if (this.isMultipleTime) {
      this.fillEndTimes();
      setTimeout(function () {
        parent.nextStep();
      }, 10);
    } else {
      this.toSelectedTime = select;
      this.fillPriceInfos();
    }


  }

  selectEndTime(select) {
    if(this.hasConsecutiveLimit(select))
      return;

    this.toSelectedTime = select;
    this.fillPriceInfos();
  }

  hasConsecutiveLimit(toTime: any) {

    this.consecutiveLimitMsg = "";
    if(!this.selectedTime)
      return true;

    if(!this.serviceItemDetail.minConsecutivePeriod)
      return false;


    let mselectedTime = moment(new Date(this.selectedTime.startTime));
    let mToTime = moment(new Date(toTime.endTime));

    let diff = new Date(this.selectedTime.endTime).getTime() -  new Date(this.selectedTime.startTime).getTime();
    var resultInMinutes = Math.round(diff / 60000);

    let tempToDate = mselectedTime.add(this.serviceItemDetail.minConsecutivePeriod * resultInMinutes , 'minutes');

    if (mToTime.isBefore(tempToDate))
    {
      this.consecutiveLimitMsg = "حداقل بازه قابل انتخاب "+ this.serviceItemDetail.minConsecutivePeriod * resultInMinutes +" دقیقه می باشد ."
      return true;
    }


    return false;
  }

  public validateBookingTimeStep(): boolean {
    this.resetMessage();
    let isValid = true;
    if (!this.selectedDate) {
      isValid = false;
      this.fromDateMessage = this.translate.instant("vmsg.fromDateIsRequired");
    }
    if (!this.selectedTime.startTime) {
      isValid = false;
      this.fromTimeMessage = this.translate.instant("vmsg.fromTimeIsRequired");
    }
    if (!this.toSelectedTime.startTime) {
      isValid = false;
      this.toTimeMessage = this.translate.instant("vmsg.toTimeIsRequired");
    }

    return isValid;
  }

  toSTR(jo: any) {
    return JSON.stringify(jo);
  }

  confirmOrderBagThen(res: PaymentResultVM) {
    if (res.status == STATUS_CREATED || res.status == STATUS_OK) {
      this.bookWasSuccessful = true;

      this.gotoPayment(res);
    }
    else {
    }


  }

  confirmIntakeForm() {
    let parent = this;

    if (this.intakeFormComponent) {
      if (this.intakeFormComponent.collectFormData()) {
        setTimeout(function () {
          parent.nextStep();
        }, 1)
      }
    }
  }

  confirmCustomerIntakeData() {
    let parent = this;

    if (this.customerIntakeDataComponent) {
      if (this.customerIntakeDataComponent.collectFormData()) {

        parent.orderBag.companyCustomer = this.companyCustomer;
        setTimeout(function () {
          parent.nextStep();
        }, 1)
      }
    }
  }


  confirmAgreement(){
    let parent = this;

    if (
      (parent.hasTheMustConfirmAgreement && parent.acceptsTermsAndConditions)
      || !parent.hasTheMustConfirmAgreement
    ) {
      setTimeout(function () {
        parent.nextStep();
      }, 1);
    } else {
      parent.showTermsAndConditionsAlert = true;
    }

  }

  selectServant(servant) {

    let parent = this;
    if (servant) {
      this.selectedDate = null;
      this.selectedServant = servant;
      this.sessionDates = [];

      if(this.isEventMode)
        this.fillEventTimes();
      else
        this.fillDates(function () {
          if (parent.canSelectServant) {
            setTimeout(function () {

              parent.nextStep();
            }, 100);
          }

        });

    }
  }

  confirmOrderBagInplacePayment() {

    this.confirmOrderBagByInplace(true);
  }

  autoSelectServant(then) {
    this.orderBagService.autoSelectServantByServiceItemId(this.serviceItemDetail.id).subscribe(function (servant) {

      if (servant) {
        if (then)
          then(servant);
      }
    });
  }

  confirmOrderBagByInplace(isInplacePayment: boolean) {
    let parent = this;
    // this.makeOrderBagObject();
    this.orderBagService.confirmOrderBag(this.orderBag).then((res) => {

      this.confirmOrderBagThen(<PaymentResultVM>res)
    }).catch((er) => {
      this.bookWasSuccessful = false;
      parent.gotoInitStep();
    });

  }

  checkIfUserCanPayInPlace() {
    let parent = this;
    parent.companyService.getCompanyInfo().subscribe((company) => {
      parent.userCanHaveInplacePayment = company.inPlacePayment;

      //if user dont have a active gateway must pay in place
      if(company.hasActivePaymentGateway)
        parent.userCanHaveOnlinePayment = true;
      else
      {
        parent.userCanHaveOnlinePayment = false;
        parent.userCanHaveInplacePayment = true;
      }


    });

  }

  checkAuthAndConfirmOrderBag() {
    let parent = this;
    if (this.authService.isAuthenticated) {
      parent.loading = true;
      this.isSaving = true;
      this.busy = this.orderBagService.saveClientReserve(this.orderBag).then((res) => {
        this.confirmOrderBagThen(<PaymentResultVM>res);
        parent.loading = false;
        this.isSaving = false;
      }).catch((er : any) => {

        this.bookWasSuccessful = false;
        parent.loading = false;
        this.isSaving = false;
        parent.setStep(0);
        parent.alertService.showErrorMessage(er);
        parent.needToBookTheReserveAfterLogin = false;
      });
    }
    else {
      this.openLoginDialog();
    }
  }

  confirmOrderBag() {
    let parent = this;

    parent.needToBookTheReserveAfterLogin = true;
    parent.checkAuthAndConfirmOrderBag();


  }

  confirmOrderBagAfterLogin() {
    let parent = this;
    if (!parent.confirmOrderFromSupport) {
      parent.confirmOrderBag();
    } else {
      parent.openDialogSupport();
    }

  }

  openLoginDialog(): void {
    let parent = this;
    this.authGuard.openLoginDialog(function () {
      if (parent.authService.isAuthenticated) {
        parent.confirmOrderBagAfterLogin();
      }
      else
      {
        setTimeout(function () {
          parent.alertService.showErrorMessage('برای ثبت رزرو لازم است ثبت نام کنید. اگر قبلا ثبت نام کرده اید وارد شوید');
      }
        , 1000)
    }});
  }

  confirmAndPayOnline() {

    this.confirmOrderBag();
  }

  confirmAndPayInPlace() {
    this.orderBag.inPlacePayment = true;
    this.confirmOrderBag();
  }

  computeOrderbagPrice(then) {
    let parent = this;
    ;
    parent.fillOrderBagObject();
    // this.makeOrderBagObject();
    parent.priceInfoComputed = false;
    parent.loading = true;
    parent.totalPrice = new OrderBagVM();

    this.busy_to_compute_price = this.orderBagService.computeOrderbagPrice(this.orderBag).subscribe(
      {
        next(tp) {
          parent.loading = false;

          parent.totalPrice = tp;
          parent.priceInfoComputed = true;
          if (parent.totalPrice.onlinePaymentAmount > 0)
            parent.userShouldPay = true;
          else
            parent.userShouldPay = false;

          // if (parent.totalPrice.onlinePaymentAmount < parent.totalPrice.finalPrice)
          if (parent.totalPrice.onlinePaymentAmount)
            parent.showPrePayment = true
          else
            parent.showPrePayment = false;
          if (then)
            then();
        },
        error(err) {
          parent.busy_to_compute_price = false;
          parent.loading = false
        },
        complete() {
        }
      })

  }

  public gotoPayment(res: PaymentResultVM): void {
    if (res.free || res.twoStepBooking || this.orderBag.inPlacePayment) {

      this.router.navigateByUrl('/booked?id=' + res.orderBagId);
    }
    else if (res.payUrl) {
      //window.location.href = PAYMENT_WEB_URL + res.authority;
      if(res.gatewayType == "SUPPLIER_AP" && res.refId)
      {
        this.goToAP(res.refId);
      }
      else if(res.gatewayType == "SUPPLIER_SEP" && res.refId)
      {
        this.goToSEP(res.refId);
      }
      else
        window.location.href = res.payUrl;
    }

  }

  goToAP(token) {
    // console.log("authority : "+ token);
    //remove "
    token = token.replace(/"/g, '');

    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://asan.shaparak.ir');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'RefId');
    hiddenField.setAttribute('value', token);
    form.appendChild(hiddenField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  goToSEP(token) {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://sep.shaparak.ir/onlinepg/onlinepg');
    // form.setAttribute('action', 'https://consult.planovin.com/#/testReturnUrl');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'Token');
    hiddenField.setAttribute('value', token);
    form.appendChild(hiddenField);

    const hiddenField2 = document.createElement("input");
    hiddenField2.setAttribute("name", "GetMethod");
    hiddenField2.setAttribute("value", "true");
    form.appendChild(hiddenField2);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  private clearExtraOrderBagItems() {
    let primeItem = this.orderBag.orderBagServiceItems[0];
    this.orderBag.orderBagServiceItems = [];
    this.orderBag.orderBagServiceItems.push(primeItem);
  }

  private fillOrderBagObject(): void {
    let parent = this;
    // this.orderBag.comment=this.bookComment;
    this.orderBagItem.serviceItemId = this.serviceItemDetail.id;
    this.orderBagItem.serviceItem = this.serviceItemDetail;
    this.orderBagItem.options = this.getOptions();
    if (this.hasIntakeForm) {
      this.orderBag.intakeData = '';
      let formData: any = {};
      formData.fields = [];
      let fields = this.serviceItemDetail.intakeForm.fields;
      fields.forEach(function (f) {
        formData.fields.push({name: f.name, label: f.label, value: f.value})
      })
      this.orderBag.intakeData = formData;
    }
    if (!this.isFloatSchedule) {
      this.orderBagItem.timeSession = this.selectedTime;
    }
    else {
      let timeSession = new SessionTimeVM();
      timeSession.startDate = this.selectedDate;
      timeSession.endDate = this.selectedDate;
      timeSession.startTime = this.selectedTime.startTime;
      //timeSession.endTime = this.selectedTime.endTime;
      //
      //if(this.isMultipleTime)
      timeSession.endTime = this.toSelectedTime.endTime;
      this.orderBagItem.timeSession = timeSession;
    }
    parent.fillServantInOrderBagItem();
  }

  private fillServantInOrderBagItem() {
    let parent = this;
    if (this.selectedServant && this.selectedServant.id) {
      parent.orderBag.orderBagServiceItems.forEach(function (orderBagItem: any) {

        orderBagItem.servant = parent.selectedServant;
      })

    }
  }

  private makeOrderBagObject(): void {
    this.orderBag = new OrderBagVM();
    this.orderBag.orderBagServiceItems = [];
    // this.orderBag.comment = this.bookComment;
    let orderBagItem: OrderBagItemVM = new OrderBagItemVM();
    orderBagItem.serviceItemId = this.serviceItemDetail.id;
    orderBagItem.orderBagServiceItemDtail = [];
    this.activePrice.gty = 1;
    this.activePrice.priceInfoDtailId = this.activePrice.id;
    this.activePrice.timeUnitQty = this.getUnitQty();
    orderBagItem.serviceItem = this.serviceItemDetail;


    orderBagItem.orderBagServiceItemDtail.push(this.activePrice);
    let timeSession: SessionTimeVM = new SessionTimeVM();
    timeSession.startTime = this.selectedTime.startTime;
    timeSession.endTime = this.toSelectedTime.endTime;
    timeSession.startDate = this.selectedDate;
    timeSession.endDate = this.selectedDate;
    orderBagItem.timeSession = timeSession;
    this.orderBag.orderBagServiceItems.push(orderBagItem);

  }

  getUnitQty() {
    if (this.serviceItemDetail.scheduleInfo && this.serviceItemDetail.scheduleInfo.floatingTimeType == 'HOURLY') {
      let selected_duration = this.computeDurationInMinutes(this.selectedTime.startTime, this.toSelectedTime.endTime);
      // let durationUnit=this.computeDurationInMinutes(this.selectedTime.startTime,this.selectedTime.endTime);
      let unitQty = Math.round((selected_duration / 60) * 100) / 100;
      return unitQty;
    }

  }

  private editDateAndTime() {
    this.changeStep(0);
  }

  private editInformation() {
    this.changeStep(1);
  }

  private finalConfirmation() {
    this.confirmOrderBagByInplace(false);
  }

  removeMultipleDate(item: OrderBagItemVM) {

    var index = this.orderBag.orderBagServiceItems.indexOf(item, 0);
    if (index > -1) {
      this.orderBag.orderBagServiceItems.splice(index, 1);
    }
  }

  openDialog(): void {
    let parent = this;
    let dialogRef = this.dialog.open(SelectDateDialogV2, {

      data: {
        activeDays: this.activeDays,
        selectedDate: this.newMultipleDate
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.addNewDateToOrderBagItem(result);

    });

  }

  private computeDurationInMinutes(startTime: Date, endTime: Date): number {
    if (startTime && endTime) {
      startTime = new Date(startTime.toString());
      endTime = new Date(endTime.toString());
      return ((endTime.getHours() - startTime.getHours()) * 60) + (endTime.getMinutes() - startTime.getMinutes());
    } else {
      return 0;
    }
  }

  private AddDaysAutomatic() {
    this.isAllAutoDatesAreFilled = true;
    let extraRepeat: number = 0;
    let filledDatesCount: number = 0;
    let primeItem: OrderBagItemVM = this.orderBag.orderBagServiceItems[0];
    if (this.serviceItemDetail.multiReserveConfig && this.serviceItemDetail.multiReserveConfig.repeatCount) {
      extraRepeat = this.serviceItemDetail.multiReserveConfig.repeatCount - 1;
    }
    if (extraRepeat > 0) {
      let nextDateOffset = 1;
      let isDayMode = (this.serviceItemDetail.multiReserveConfig.repeatMode == 'DAY_PERIOD');
      if (!isDayMode)//it is weekly
        nextDateOffset = 7;

      let baseDate = primeItem.timeSession.startDate;
      let mTime = Moment(new Date(baseDate));

      let i = 0;
      let repeatedDateList: Date[] = [];
      while (filledDatesCount < extraRepeat && i < 100) {

        mTime = mTime.add(nextDateOffset, 'days');
        if (this.isSelectedDateInAvailableDate(mTime)) {
          this.addNewDateToOrderBagItem(mTime.toDate())
          filledDatesCount++;
        }
        i++;
      }
      if (filledDatesCount < extraRepeat)
        this.isAllAutoDatesAreFilled = false;

    }

  }

  private addNewDateToOrderBagItem(result: any): void {

    let primeItem = this.orderBag.orderBagServiceItems[0];
    let newItem = JSON.parse(JSON.stringify(primeItem));
    newItem.timeSession.startDate = result;
    newItem.index = this.orderBag.orderBagServiceItems.length;
    this.setTimeForNewDate(primeItem, newItem, newItem.timeSession.startDate)

  }

  setTimeForNewDate(currentItem, newItem, newDate) {
    let parent = this;

    if (this.serviceItemDetail && newDate) {
      parent.loading = true;
      let servantid = null;
      if (this.selectedServant && this.selectedServant.id)
        servantid = this.selectedServant.id;
      parent.busy_to_fill_times = this.categoryService.getServiceSessionTimesByServiceidAndServant(this.serviceItemDetail.id, servantid, newDate).subscribe(
        {
          next(sd) {
            let isAvailable = parent.isDateAvailable(sd, currentItem);
            if (isAvailable) {
              //if (!this.isFloatSchedule) {
              //  //finding timesessionid
              //  sd.forEach(function (time) {
              //    if (parent.compareTimePart(time.startTime, currentItem.timeSession.startTime) == 0) {
              //      newItem.timeSession.id = time.id;
              //      newItem.timeSession.startDate = time.startTime;
              //      newItem.timeSession.endDate = time.endTime;
              //      newItem.timeSession.startTime = time.startTime;
              //      newItem.timeSession.endTime = time.endTime;
              //    }
              //  })
              //}
              //else {
              newItem.timeSession.startDate = newDate;
              newItem.timeSession.endDate = newDate;
              newItem.timeSession.startTime = parent.concatTimeAndDate(currentItem.timeSession.startTime, newDate);
              newItem.timeSession.endTime = parent.concatTimeAndDate(currentItem.timeSession.endTime, newDate);

              //}

              if (parent.compareDatePart(newItem.timeSession.startDate, currentItem.timeSession.startDate) != 0)
              {
                newItem.index = parent.orderBag.orderBagServiceItems.length;
                parent.orderBag.orderBagServiceItems.push(newItem);
              }
            }
            else {
              if (parent.isAutoSelectMultipleDates) {
                parent.isAllAutoDatesAreFilled = false;
              }
              else {
                parent.alertService.showErrorMessage('error.reserveTimeIsnotAvailableInGivenDate');
              }
            }
            parent.orderBag.orderBagServiceItems.sort((val1, val2) => {
              return <any>new Date(val1.timeSession.startDate) - <any>new Date(val2.timeSession.startDate);
            })
            parent.loading = false;

            parent.toSessionTimes = [];
          },
          error(err) {
            parent.loading = false;
            parent.busy_to_fill_times = false;
          },
          complete() {
          }
        }
      );
    }
  }

  isDateAvailable(avTimes: SessionTimeVM[], currentItem: any): boolean {
    let parent = this;
    let totalQty = parent.getTotalQty();
    let isAvailable = true;
    let isTimeInList = false;
    avTimes.forEach(function (time) {
      if (parent.hasTimeConflict(currentItem.timeSession, time)) {
        isTimeInList = true;
        if (totalQty > time.capacity || time.disabled)
          isAvailable = false;
      }
    })

    if(!isTimeInList)
      isAvailable = false;



    return isAvailable;


  }

  hasTimeConflict(timeSession: SessionTimeVM, time: SessionTimeVM): any {
    let start1 = timeSession.startTime;
    let end1 = timeSession.endTime;
    let start2 = time.startTime;
    let end2 = time.endTime;

    if (this.isTimeInPeriod(start1, start2, end2) || this.isTimeInPeriod(start2, start1, end1)) {
      return true;
    }
    return false;
  }

  private isTimeInPeriod(start1: Date, start2: Date, end2: Date): any {
    let parent = this;
    return (parent.compareTimePart(start1, start2) >= 0 && parent.compareTimePart(start1, end2) < 0)
  }

  private compareTimePart(start1: Date, start2: Date) {
    start1 = new Date(start1.toString())
    start2 = new Date(start2.toString())
    let timeInMin1 = start1.getHours() * 60 + start1.getMinutes();
    let timeInMin2 = start2.getHours() * 60 + start2.getMinutes();

    if (timeInMin1 > timeInMin2) return 1;
    if (timeInMin1 < timeInMin2) return -1;
    if (timeInMin1 == timeInMin2) return 0;


  }

  private compareDatePart(start1: Date, start2: Date) {
    start1 = new Date(start1.toString())
    start2 = new Date(start2.toString())

    start1.setHours(0, 0, 0, 0);
    start2.setHours(0, 0, 0, 0);

    if (start1.valueOf() === start2.valueOf()) return 0;
    if (start1.valueOf() > start2.valueOf()) return 1;
    if (start1.valueOf() < start2.valueOf()) return -1;


  }

  concatTimeAndDate(time: Date, date: Date) {

    if (time && date) {

      let retDateTime = new Date(time);
      retDateTime.setFullYear(date.getFullYear());

      retDateTime.setMonth(date.getMonth(),date.getDate());
      retDateTime.setDate(date.getDate());
      return retDateTime;
    }
    else {
      return time;
    }
  }

  private isSelectedDateInAvailableDate(mTime): any {
    let exists = false;
    this.activeDays.forEach(function (dob) {
      let d = dob.startDate;
      let secondMoment = moment(new Date(d));
      if (mTime.startOf('day').isSame(secondMoment.startOf('day')))
        exists = true;
    });

    return exists;
  }

  public sortAvailableDays(arrayDays): any {
   let result = arrayDays.sort((val1,val2) => {
     return <any>new Date(val1.startDate) - <any>new Date(val2.startDate);
    });
   return result;
  }

  private gotoInitStep() {
    if (this.canSelectServant)
      this.setStep(0);
    else
      this.setStep(1);
  }

  openDialogTermsAndConditions(): void {
    let parent = this;
    const dialogConfig = new MatDialogConfig();


    dialogConfig.data = {
      html: this.serviceItemDetail.agreement.agreement
    };
    this.dialog.open(DialogTermsAndConditionsComponent, dialogConfig);

  }

  openDialogSupport(): void {
    let parent = this;
    if (parent.hasTheMustConfirmAgreement && parent.acceptsTermsAndConditions) {
      parent.confirmOrderBagFromSupport();
    } else {
      parent.showTermsAndConditionsAlert = true;
    }
    if (!parent.hasTheMustConfirmAgreement) {
      parent.confirmOrderBagFromSupport();
    }
  }

  confirmOrderBagFromSupport() {
    let parent = this;
    parent.confirmOrderFromSupport = true;
    let dialogData: any = {user: '', password: ''};
    if (this.authService.isAuthenticated) {
      const dialogRef = this.dialog.open(SupportedCompanyInformationDialogComponent, {
        // width: '320px',
        data: dialogData
      });


      dialogRef.afterClosed().subscribe(result => {

        this.orderBag.inPlacePayment = true;
        if (dialogData && dialogData.user && dialogData.password)
          this.busy = this.orderBagService.saveAppviserClientReserve(this.orderBag, dialogData.user, dialogData.password).then((res) => {
            this.confirmOrderBagThen(<PaymentResultVM>res)
            parent.loading = false;
          }).catch((er) => {

            this.bookWasSuccessful = false;
            parent.loading = false;
            //   parent.gotoInitStep();
            //   parent.alertService.showErrorMessage(er);

          });
      });
    } else {
      this.openLoginDialog();
    }
  }

  checkCouponCode(){

    if(this.orderBag.couponToCheckValidity)
    {
      this.showCouponResult = false;
      this.orderBagService.evaluateCoupon(this.orderBag).subscribe((cs) => {

        this.computeOrderbagPrice(function(){
          // some code
        });
        if(cs.resultStatus=='DONE')
        {

          this.couponResult =cs;
          this.showCouponResult = true;

        }

        else{
          this.showCouponResult = false;
          //make error
        }

      },error => {

        this.computeOrderbagPrice(function(){
          // some code
        });

      } )

    }




  }

  findFirstAvailableDate(){
    var keepGoing = true;
    this.activeDays = this.sortAvailableDays(this.activeDays)

    this.activeDays.forEach((day) => {
      if(keepGoing)
      {
         if(day.capacity >0)
         {
           this.selectedDateChanged(day.startDate);
           // this.datePickerComponent.moveToDate(day.startDate);
           this.rwDatePicker.moveToDate(day.startDate);
           keepGoing = false;
         }
      }
    })

    if(keepGoing)
    {
      this.alertService.showErrorMessage("تاریخ خالی پیدا نشد.");
    }

  }

  showCouponCodeSection(){
    this.showCouponSection = !this.showCouponSection;
  }

  getServantDescription(srv)
  {
    if(srv && srv.description)
    {
        let showChar = 35;
        let ellipsesText = " ...";
        if(srv.description.length > showChar)
        {
          let minimize = srv.description.substr(0, showChar);
          minimize = minimize + ellipsesText;
          return minimize;
        }

        return srv.description ;
    }

    return null;
  }

  showServantMoreButton(srv){

    if(srv && srv.description) {
      let showChar = 35;
      if (srv.description.length > showChar) {
        return true;
      }
      return false;
    }
    return false;
  }

  onServantMoreClick(srv)
  {
    const dialogConfig = new MatDialogConfig();


    dialogConfig.data = srv;
    this.dialog.open(DialogServantProfileComponent,dialogConfig );
  }

  getServantPrice(srv)
  {
    if(srv.priceInfoDtails && srv.priceInfoDtails.length > 0)
    {
       return srv.priceInfoDtails[0].price;
    }
    else{
      if(this.isAnyServantHasCustomPrice)
        return this.serviceItemDetail.minPrice ;
    }
  }
  showServantPrice(srv)
  {
    //Must check ShowPrice from company Setting
    if(!this.showPrice)
    {
      return false;
    }

    if( (srv.priceInfoDtails && srv.priceInfoDtails.length > 0) || this.isAnyServantHasCustomPrice)
    {
        this.isAnyServantHasCustomPrice = true;
        return true;
    }

    return false;
  }
  sortServants()
  {
     if(this.serviceItemDetail.servants)
     {
       this.serviceItemDetail.servants.sort((a, b) => {
         if (a.code && b.code)
           return (a.code < b.code ? -1 : 1);
         else
         {
           if(!a.code && b.code)
             return (1);
           if(a.code && !b.code)
             return (-1);

           return (a.servantName < b.servantName ? -1 : 1);
         }

       });
     }
  }

  fillEventTimes() {
    let parent = this;
    if (this.serviceItemDetail ) {
      parent.loading = true;
      let servantid = null;
      if (this.selectedServant && this.selectedServant.id)
        servantid = this.selectedServant.id;

      parent.busy_to_fill_times = this.categoryService.getAllAvailableTimesByServiceAndServant(this.serviceItemDetail.id, servantid).subscribe(
        {
          next(sd) {

            parent.sessionTimes = sd;
            parent.notTimeAvailable = true;
            parent.sessionTimes.forEach(function (t) {
              // if (t.capacity > 0 && !parent.isExpired(t.startTime))
              if (t.capacity > 0)
                parent.notTimeAvailable = false;
              if(t.capacity == 0)
                t.disabled = true;
            })

            parent.sessionTimes = parent.sortEventTimes(parent.sessionTimes);
            parent.loading = false;
            parent.nextStep();
            parent.loading = false;
            parent.busy_to_fill_times = false;
          },
          error(err) {
            parent.loading = false;
            parent.busy_to_fill_times = false;
          },
          complete() {
          }
        }
      );
    }
    else {
      this.sessionTimes = [];
    }
  }

  selectEventTime(ev) {

    let parent = this;
    let date = new Date(ev.startTime) ;
    parent.selectedDate = date;
    parent.selectedTime = ev;
    this.toSelectedTime = ev;
    parent.fillPriceInfos();

  }

  public sortEventTimes(arrayTimes): any {
    let result = arrayTimes.sort((val1,val2) => {
      return <any>new Date(val1.startTime) - <any>new Date(val2.startTime);
    });
    return result;
  }

  public getListOfOptionQty(option):any{
    let qtyList = [];
    for(let i= option.minQty ; i <= option.maxQty ; i++)
    {
      qtyList.push(i);
    }

    return qtyList;
  }

  private isDateInFirstHalf(date: Date) {
    let startDate = new Date(date.getFullYear(),2,20);

    let endDate = new Date(date.getFullYear(),8,22);

    if(date > startDate && date < endDate )
      return true;

    return false;
  }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/book-toolbar-v2/book-toolbar-v2.component.ts